import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { preloadListAssets, preloadListAssetTags } from '@/api/react-query'
import { AssetLibraryPage } from '@/components/asset-library-page'
import { DEFAULT_PAGE_SIZE } from '@/components/table/pagination'
import { useI18n } from '@/i18n/i18n-react'

const LibrarySearchSchema = z.object({
	limit: z.coerce.number().min(1).max(100).default(DEFAULT_PAGE_SIZE),
	offset: z.coerce.number().default(0),
	q: z.string().optional(),
	tags: z.array(z.string()).optional(),
	usage: z.enum(['UNUSED', 'PRODUCT', 'PRODUCT_GROUP', 'PRODUCT_CATEGORY']).optional(),
	view: z.enum(['table', 'gallery']).default('table')
})

export const Route = createFileRoute('/_authenticated/_general/products/library')({
	component: ProductLibraryPage,
	validateSearch: LibrarySearchSchema,
	loaderDeps: ({ search: { limit, offset, q, tags, usage } }) => ({ limit, offset, q, tags, usage }),
	loader: async ({ context, deps: { limit, offset, q, tags, usage } }) => {
		await Promise.all([
			preloadListAssets(context, {
				query: {
					category: ['PRODUCT'],
					q,
					tags: tags?.length ? tags : undefined,
					usage,
					limit,
					offset
				}
			}),
			preloadListAssetTags(context, { query: { category: 'PRODUCT' } })
		])
	},
	staticData: {
		crumb: ({ context: { L } }) => L.Products.Library()
	}
})

function ProductLibraryPage() {
	const { L } = useI18n()
	return <AssetLibraryPage category='PRODUCT' heading={L.Products.Library()} copy={L.Products.LibraryPage} />
}
